import React from 'react'
import PropTypes from 'prop-types'
import formatDate from 'date-fns/format'
import isValidDate from 'date-fns/isValid'
import { Box } from '@maui/elements'
import { formatDistanceDate } from '../../utilities'

export const formats = {
  medium: (date) => formatDate(date, 'MMMM d, yyyy'),
  distance: (date) => formatDistanceDate(date),
}

export const Timestamp = ({ fallback, format, value, ...props }) => {
  const date = new Date(value)
  const formatter = formats[format]
    ? formats[format]
    : () => formatDate(date, format)

  return (
    <Box as="span" {...props} letterSpacing='1px' textTransform='uppercase'>
      {isValidDate(date) ? formatter(date) : fallback}
    </Box>
  )
}

Timestamp.propTypes = {
  fallback: PropTypes.string,
  format: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]).isRequired,
}

Timestamp.defaultProps = {
  fallback: 'Unknown',
  format: 'medium',
}
